import { Loadable } from './isLoading';

export const findLoadable = (ids?: string[], targetId?: Loadable<string>) => {
  return !!targetId && !!ids && ids.includes(targetId);
};
